import { filter } from 'rxjs/operators';

export function filterNil<T>() {
    return filter<T>(value => value !== null && value !== undefined);
}
